import { useEffect, useState } from 'react';

const getCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return currentTime;
};

export const getRemainingTime = pickupDate => {
  const currentTime = getCurrentTime();

  const targetUTCTimeStr = pickupDate;

  if (!targetUTCTimeStr) return { timer: '---', color: 'var(--timer-text)' };

  // Parse the target UTC time
  const targetTime = pickupDate?.includes('Z')
    ? new Date(pickupDate)
    : new Date(pickupDate + 'Z');
  const timeDifference = targetTime - currentTime;
  const isInFuture = timeDifference > 0;
  const absDifference = Math.abs(timeDifference);
  const seconds = Math.floor((absDifference / 1000) % 60);
  const minutes = Math.floor((absDifference / (1000 * 60)) % 60);
  const hours = Math.floor((absDifference / (1000 * 60 * 60)) % 24);

  const firstWarning = 6;
  const secondWarning = 4;
  const thirdWarning = 2;

  const convertToSecs = Math.floor(absDifference / 1000);
  const converToMinutes = Math.round(convertToSecs / 60);
  if (isInFuture) {
    if (converToMinutes < 1) {
      let ss = String(seconds).padStart(2, '0');
      return {
        timer: `00:${ss}`,
        color: 'var(--timer-text-red)',
      };
    }

    if (convertToSecs > firstWarning * 60) {
      if (convertToSecs > firstWarning * 60 && convertToSecs <= 3540) {
        let mm = String(minutes).padStart(2, '0');
        let ss = String(seconds).padStart(2, '0');

        return {
          timer: `${mm}:${ss}`,
          color: 'var(--timer-text)',
        };
      } else if (convertToSecs > 3600) {
        let hh = hours > 4 ? `4h+` : `${hours}h+`;

        return {
          timer: hh,
          color: 'var(--timer-text)',
        };
      }
    } else if (
      convertToSecs <= firstWarning * 60 &&
      convertToSecs > secondWarning * 60
    ) {
      let mm = String(minutes).padStart(2, '0');
      let ss = String(seconds).padStart(2, '0');

      return {
        timer: `${mm}:${ss}`,
        color: 'var(--timer-text-yellow)',
      };
    } else if (
      convertToSecs <= secondWarning * 60 &&
      convertToSecs > thirdWarning * 60
    ) {
      let mm = String(minutes).padStart(2, '0');
      let ss = String(seconds).padStart(2, '0');

      return {
        timer: `${mm}:${ss}`,
        color: 'var(--timer-text-orange)',
      };
    } else if (convertToSecs <= thirdWarning * 60) {
      let mm = String(minutes).padStart(2, '0');
      let ss = String(seconds).padStart(2, '0');

      return {
        timer: `${mm}:${ss}`,
        color: 'var(--timer-text-red)',
      };
    }
  }
  if (converToMinutes < 1) {
    let ss = String(seconds).padStart(2, '0');
    return { timer: `00:${ss}`, color: 'var(--timer-text-red)' };
  }

  if (converToMinutes >= 1 && converToMinutes <= 59) {
    let mm = String(minutes).padStart(2, '0');
    let ss = String(seconds).padStart(2, '0');
    return { timer: `${mm}:${ss}`, color: 'var(--timer-text-red)' };
  }

  let hh = hours > 4 ? '4h+' : `${hours}h+`;
  return { timer: hh, color: 'var(--timer-text-red)' };
};

export const getEllapsedTime = date => {
  const currentTime = getCurrentTime();

  if (!date)
    return {
      timer: `---`,
      color: 'var(--timer-text)',
    };
  let openDate;
  if (!date?.includes('Z')) {
    openDate = new Date(date + 'Z');
  } else {
    openDate = new Date(date);
  }
  const currTime = currentTime;
  const diff = currTime - openDate;
  const absDiff = Math.abs(diff);
  const seconds = Math.floor((absDiff / 1000) % 60);
  const minutes = Math.floor((absDiff / (1000 * 60)) % 60);
  const hours = Math.floor((absDiff / (1000 * 60 * 60)) % 24);
  if (minutes < 1 && seconds >= 0) {
    let ss = String(seconds).padStart(2, '0');

    return {
      timer: `00:${ss}`,
      color: 'var(--timer-text)',
    };
  } else if (minutes >= 1 && minutes < 60 && hours < 1) {
    let mm = String(minutes).padStart(2, '0');
    let ss = String(seconds).padStart(2, '0');

    return {
      timer: `${mm}:${ss}`,
      color: 'var(--timer-text)',
    };
  } else {
    let hh = hours > 4 ? '4h+' : `${hours}h+`;

    return {
      timer: hh,
      color: 'var(--timer-text)',
    };
  }
};
